// Simple up/down reordering instead of drag-and-drop (spec §38: "do not
// make drag-and-drop mandatory ... provide simple alternatives") — this is
// the only alternative implemented in V1, and it's enough for lists of the
// size a restaurant menu actually has.
export function moveId(ids, id, direction) {
  const index = ids.indexOf(id);
  const swapWith = index + direction;
  if (index === -1 || swapWith < 0 || swapWith >= ids.length) return ids;
  const next = [...ids];
  [next[index], next[swapWith]] = [next[swapWith], next[index]];
  return next;
}
